import React from "react";
import { StyledSVG, Wrapper } from "./IconStyle";
import { useLocation } from "react-router";

export const routeActiveMonitoring = ["monitoring"];

const MonitoringIcon = () => {
  const { pathname } = useLocation();
  return (
    <Wrapper>
      {routeActiveMonitoring.some((item) =>
        item.includes(pathname.split("/")[1])
      ) ? (
        <StyledSVG
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1584 9.02917L19.6992 18.095C19.7176 18.3425 19.5984 18.5075 19.5342 18.5808C19.4609 18.6633 19.3051 18.7917 19.0484 18.7917H16.5459L18.5259 9.02917H19.1584ZM20.1667 5.5L20.1576 5.51833C20.1759 5.73833 20.1576 5.9675 20.1026 6.19667L13.3467 18.5992C13.1267 19.525 12.3017 20.1667 11.3484 20.1667H19.0484C20.2309 20.1667 21.1659 19.1675 21.0742 17.985L20.1667 5.5Z"
            fill="#20A2A2"
          />
          <path
            d="M10.4959 2.05312C10.5876 1.68645 10.3584 1.31062 9.99172 1.21895C9.62505 1.13645 9.24922 1.35645 9.15755 1.72312L8.69922 3.62062H10.1109L10.4959 2.05312Z"
            fill="#20A2A2"
          />
          <path
            d="M16.5459 2.026C16.6284 1.65017 16.3901 1.29267 16.0142 1.21017C15.6476 1.12767 15.2809 1.366 15.1984 1.74184L14.7859 3.63934H16.1976L16.5459 2.026Z"
            fill="#20A2A2"
          />
          <path
            d="M20.0016 4.88598C19.6991 4.15265 18.9841 3.63015 18.1041 3.63015H16.1975L15.6841 6.00432C15.6108 6.32515 15.3266 6.54515 15.015 6.54515C14.9691 6.54515 14.9141 6.54515 14.8683 6.52682C14.5016 6.44432 14.2633 6.07765 14.3366 5.71098L14.7858 3.62098H10.1108L9.53331 6.00432C9.45998 6.31598 9.17581 6.52682 8.86415 6.52682C8.80915 6.52682 8.75415 6.51765 8.69915 6.50848C8.33248 6.41682 8.10331 6.05015 8.19498 5.67432L8.68998 3.61182H6.82914C5.93081 3.61182 5.13331 4.19848 4.86748 5.06015L1.00831 17.481C0.604978 18.8101 1.58581 20.1668 2.96998 20.1668H15.015C15.9683 20.1668 16.7933 19.5252 17.0133 18.5993L20.1025 6.19682C20.1575 5.96765 20.1758 5.73848 20.1575 5.51848C20.1391 5.29848 20.0933 5.07848 20.0016 4.88598ZM13.475 15.3543H6.14164C5.76581 15.3543 5.45414 15.0426 5.45414 14.6668C5.45414 14.291 5.76581 13.9793 6.14164 13.9793H13.475C13.8508 13.9793 14.1625 14.291 14.1625 14.6668C14.1625 15.0426 13.8508 15.3543 13.475 15.3543ZM14.3916 11.6876H7.05831C6.68248 11.6876 6.37081 11.376 6.37081 11.0001C6.37081 10.6243 6.68248 10.3126 7.05831 10.3126H14.3916C14.7675 10.3126 15.0791 10.6243 15.0791 11.0001C15.0791 11.376 14.7675 11.6876 14.3916 11.6876Z"
            fill="#20A2A2"
          />
        </StyledSVG>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0149 20.854H2.96989C2.09906 20.854 1.2924 20.4507 0.769897 19.7449C0.23823 19.0299 0.0824046 18.1315 0.348238 17.279L4.2074 4.87643C4.55573 3.72143 5.61908 2.93311 6.82908 2.93311H18.1041C19.2132 2.93311 20.2124 3.59319 20.6341 4.61985C20.8632 5.15152 20.9091 5.75653 20.7716 6.35237L17.6824 18.7548C17.3891 19.9923 16.2891 20.854 15.0149 20.854ZM6.83823 4.31728C6.24239 4.31728 5.70157 4.7115 5.5274 5.289L1.66824 17.6915C1.53991 18.1224 1.61323 18.5715 1.88823 18.9382C2.1449 19.2865 2.54823 19.4882 2.97907 19.4882H15.0241C15.6566 19.4882 16.2066 19.0573 16.3532 18.4431L19.4424 6.03144C19.5157 5.72894 19.4974 5.42649 19.3782 5.16065C19.1582 4.63815 18.6724 4.30811 18.1132 4.30811H6.83823V4.31728Z"
            fill="#454F5B"
          />
          <path
            d="M19.0483 20.8541H14.6666C14.2908 20.8541 13.9791 20.5424 13.9791 20.1666C13.9791 19.7907 14.2908 19.4791 14.6666 19.4791H19.0483C19.4241 19.4791 19.7725 19.3232 20.0291 19.0482C20.2858 18.7732 20.4141 18.4066 20.3866 18.0308L19.4791 5.54577C19.4516 5.16993 19.7358 4.83989 20.1116 4.81239C20.4875 4.79406 20.8175 5.069 20.845 5.44484L21.7525 17.9299C21.8075 18.6816 21.5416 19.4333 21.0283 19.9833C20.5241 20.5424 19.8 20.8541 19.0483 20.8541Z"
            fill="#454F5B"
          />
          <path
            d="M8.87308 6.53565C8.81808 6.53565 8.76309 6.52647 8.70809 6.5173C8.34142 6.42563 8.11226 6.05894 8.20393 5.6831L9.15724 1.72315C9.24891 1.35649 9.61558 1.12727 9.99141 1.21894C10.3581 1.31061 10.5873 1.67731 10.4956 2.05314L9.54226 6.0132C9.46892 6.32487 9.18474 6.53565 8.87308 6.53565Z"
            fill="#454F5B"
          />
          <path
            d="M15.0149 6.54476C14.9691 6.54476 14.9141 6.54475 14.8683 6.52641C14.5016 6.44391 14.2633 6.07723 14.3366 5.71057L15.1983 1.73226C15.2808 1.35643 15.6474 1.1273 16.0141 1.20064C16.3808 1.27397 16.6191 1.64971 16.5458 2.01637L15.6841 5.99479C15.6199 6.32479 15.3358 6.54476 15.0149 6.54476Z"
            fill="#454F5B"
          />
          <path
            d="M14.3918 11.6875H7.05847C6.68264 11.6875 6.37097 11.3758 6.37097 11C6.37097 10.6242 6.68264 10.3125 7.05847 10.3125H14.3918C14.7676 10.3125 15.0793 10.6242 15.0793 11C15.0793 11.3758 14.7676 11.6875 14.3918 11.6875Z"
            fill="#454F5B"
          />
          <path
            d="M13.4752 15.354H6.14185C5.76601 15.354 5.45435 15.0423 5.45435 14.6665C5.45435 14.2907 5.76601 13.979 6.14185 13.979H13.4752C13.851 13.979 14.1627 14.2907 14.1627 14.6665C14.1627 15.0423 13.851 15.354 13.4752 15.354Z"
            fill="#454F5B"
          />
        </svg>
      )}
    </Wrapper>
  );
};

export default MonitoringIcon;
